import React, { FC } from "react";
import { FiArrowRight } from "react-icons/fi";

/**
 * Wallet balance KPI card. The legacy styling props (customClass, pointClass,
 * circleClass ...) are still accepted so existing callers compile, but the
 * card now takes its look from the design system.
 */
export interface ICard {
  points?: any;
  customClass?: any;
  pointClass?: any;
  groupsvg?: any;
  RedeemClass?: any;
  pointBalance?: any;
  selectPointClass?: any;
  circleClass?: any;
  svgClass?: any;
  BalanceClass?: any;
  pointBalanceClass?: any;
  redeem?: any;
  onselect: () => void;
}

export const WalletCard: FC<ICard> = ({ points, groupsvg, pointBalance, redeem, onselect }) => {
  const isLoading = !!points?.length;

  return (
    <div className="h-full zs-stat">
      <div className="flex items-start justify-between gap-3">
        <span className="zs-stat-label">{pointBalance}</span>
        {groupsvg && (
          <span className="zs-stat-icon !bg-primary">
            <img src={groupsvg} alt="" className="w-[18px] h-[18px]" />
          </span>
        )}
      </div>
      {isLoading ? <div className="w-24 h-7 zs-skeleton" /> : <div className="zs-stat-value">{points}</div>}
      <div className="flex items-center justify-between gap-2 pt-1 mt-auto">
        <span className="zs-stat-meta">Points</span>
        <button type="button" onClick={onselect} className="zs-btn zs-btn-ghost zs-btn-sm !px-2 text-primary-text">
          {redeem}
          <FiArrowRight />
        </button>
      </div>
    </div>
  );
};
